import { can, CAPABILITY } from '../../../actions/permissions.js';

export const AI_ANALYSIS_ACTION_PERMISSIONS = Object.freeze({
  LOAD_JOBS: CAPABILITY.AI_ANALYSIS_VIEW,
  LOAD_FINDINGS: CAPABILITY.AI_ANALYSIS_VIEW,
  REFRESH_PROCESSING_COUNT: CAPABILITY.AI_ANALYSIS_VIEW,
  ENSURE_POLLING: CAPABILITY.AI_ANALYSIS_VIEW,
  POLL_JOBS: CAPABILITY.AI_ANALYSIS_VIEW,
  LOAD_SNAPS: CAPABILITY.AI_ANALYSIS_RUN,
  LOAD_ALL_SNAPS: CAPABILITY.AI_ANALYSIS_RUN,
  START_FULL_SCAN: CAPABILITY.AI_ANALYSIS_RUN,
  START_AVA_INSPECT_RUN: CAPABILITY.AI_ANALYSIS_RUN,
  CANCEL_JOB: CAPABILITY.AI_ANALYSIS_RUN,
  ACCEPT: CAPABILITY.AI_ANALYSIS_REVIEW,
  REJECT: CAPABILITY.AI_ANALYSIS_REVIEW,
  ACCEPT_ALL: CAPABILITY.AI_ANALYSIS_REVIEW,
  REJECT_ALL: CAPABILITY.AI_ANALYSIS_REVIEW,
  LINK_COMPONENT: CAPABILITY.AI_ANALYSIS_REVIEW,
});

export function requireAiAnalysisRun(rootGetters) {
  if (!can(CAPABILITY.AI_ANALYSIS_RUN, { getters: rootGetters })) {
    throw new Error('You do not have permission to run AI analysis.');
  }
}

export function mayReplaceReviewedFindings(rootGetters) {
  return can(CAPABILITY.AI_ANALYSIS_REVIEW, { getters: rootGetters });
}

// Recheck after confirmations and between bulk writes. Never commit a response from
// another account/facility, or after the required grant was removed in this session.
export function authorizeAiAnalysisAction(action, capability) {
  return async (context, payload) => {
    const store = { getters: context.rootGetters };
    const user = context.rootGetters && context.rootGetters['ACCOUNT/GET_USER'];
    let facilityId = context.state.facilityId;
    let scopeVersion = context.state.scopeVersion;
    const allowed = () => can(capability, store)
      && context.rootGetters['ACCOUNT/GET_USER'] === user
      && context.state.scopeVersion === scopeVersion
      && (!facilityId || context.state.facilityId === facilityId);
    const requirePermission = () => {
      if (!allowed()) throw new Error('You do not have permission for this AI analysis action.');
    };
    requirePermission();
    const guarded = {
      ...context,
      commit(type, value, options) {
        if (!allowed()) return;
        context.commit(type, value, options);
        // LOAD_JOBS owns its synchronous facility transition before awaiting HTTP.
        if (type === 'RESET' || type === 'SET_FACILITY_ID') {
          facilityId = context.state.facilityId;
          scopeVersion = context.state.scopeVersion;
        }
      },
      dispatch(type, value, options) { requirePermission(); return context.dispatch(type, value, options); },
    };
    try {
      return await action(guarded, payload);
    } catch (err) {
      if (err && err.response && err.response.status === 403) {
        context.dispatch('STOP_POLLING');
        context.commit('RESET');
      }
      throw err;
    }
  };
}
